export const environment = {
  tag: 'PROD',
  localStoragePrefix: 'sispg',
  production: true,
  clientId: 'unesp.sispg-v3',
  name: 'PROPG - Pró-reitoria de Pós-graduação',
  baseUrlApi: 'https://app.unesp.br/sispg-api',
  baseUrlRedirect: 'https://app.unesp.br/sispg/auth/',
  oauthAuthorize: 'https://auth.unesp.br/oauth/authorize',
  centralRolePrefix: 'ROLE_UNESP.SISPG-V3_',
  refreshTokenExpirationInSeconds: 3600,
  refreshTokenExpirationActivityNotificationsTime: [1800, 600, 300, 180, 120],
  refreshTokenExpirationLastWarningTime: 61,
  roles: {
    ALUNO_ESPECIAL: {
      name: 'ROLE_UNESP.SISPG-V3_ASSE',
      desc: 'ALUNO_ESPECIAL',
    },
    ALUNO_REGULAR: {
      name: 'ROLE_UNESP.SISPG-V3_ASSR',
      desc: 'ALUNO_REGULAR',
    },
    AREX: {
      name: 'ROLE_UNESP.SISPG-V3_AREX',
      desc: 'AREX',
    },
    CANDIDATO: {
      name: 'ROLE_UNESP.SISPG-V3_CANDIDATO',
      desc: 'Candidato',
    },
    CCD: {
      name: 'ROLE_UNESP.SISPG-V3_CCD',
      desc: 'CCD',
    },
    CONSULTA_DISCENTE: {
      name: 'ROLE_UNESP.SISPG-V3_CONSULTADISCENTE',
      desc: 'CONSULTA_DISCENTE',
    },
    DTA: {
      name: 'ROLE_UNESP.SISPG-V3_DTA',
      desc: 'DTA',
    },
    DOCENTE: {
      name: 'ROLE_UNESP.SISPG-V3_DOCENTE',
      desc: 'DOCENTE',
    },
    PROPG: {
      name: 'ROLE_UNESP.SISPG-V3_PROPG',
      desc: 'PROPG',
    },
    RESIDENCIA: {
      name: 'ROLE_UNESP.SISPG-V3_RESIDENCIA',
      desc: 'RESIDENCIA',
    },
    STPG: {
      name: 'ROLE_UNESP.SISPG-V3_STPG',
      desc: 'STPG',
    },
  },
  servicedesk: 'https://servicedesk.unesp.br/portfolio/runesp/sispg',
  centralAcessos: 'https://sistemas.unesp.br/central/',
  intercambio: 'https://app.unesp.br/sispropg/propostas/disponiveis/internacionalizacao/mobilidade',
  recaptcha: {
    siteKey: '6Lc1slImAAAAAK0UrRu_fsyWIP2HH7KdN-4gFGAu',
  },
  ssoLoginLegado: 'https://app.unesp.br/posgraduacao/ssoLogin.action',
}
